import {UI} from "../../../stem-core/ui/UIBase";
import {DonationOffer} from "../../../client/state/DonationOfferStore";
import {DashboardTitle} from "../../common/DashboardTitle";
import {DonationOfferEditor} from "./components/DonationOfferEditor.jsx";
import type {Merchant} from "../../../client/state/MerchantStore";


interface MerchantDonationSettingsPageOptions {
    merchant?: Merchant;
}

export class MerchantDonationSettingsPage extends UI.Element<MerchantDonationSettingsPageOptions> {
    render() {
        const {merchant} = this.options;
        const donationOffer = DonationOffer.findBy({merchant});

        return [
            <DashboardTitle
                title="Donation settings"
                description="Configure everything related to the donation flows"
            />,

            donationOffer ?
                <DonationOfferEditor donationOffer={donationOffer}/>
                :
                <div style={{fontSize: 18, marginTop: 24}}>
                    Donations are not enabled, you can active them by contacting us at <a>biz.support@blink.net</a>.
                </div>
        ]

    }
}
